/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { OfferApiConfiguration } from '../offer-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PomProductDefinitionResponseDto } from '../models/pom-product-definition-response-dto';

@Injectable({
  providedIn: 'root',
})
export class ProductDefinitionService extends BaseService {
  constructor(
    config: OfferApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation details
   */
  static readonly DetailsPath = '/product-definition';

  /**
   * Get details for one product definition
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `details()` instead.
   *
   * This method doesn't expect any request body.
   */
  details$Response(params: {

    /**
     * Product code
     */
    productCode: string;

    /**
     * Variant code
     */
    variantCode?: string;

    /**
     * Date
     */
    date?: string;

    /**
     * Is full product flag
     */
    fullProduct?: boolean;
    'Accept-Language'?: any;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PomProductDefinitionResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProductDefinitionService.DetailsPath, 'get');
    if (params) {
      rb.query('productCode', params.productCode, {});
      rb.query('variantCode', params.variantCode, {});
      rb.query('date', params.date, {});
      rb.query('fullProduct', params.fullProduct, {});
      rb.header('Accept-Language', params['Accept-Language'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PomProductDefinitionResponseDto>;
      })
    );
  }

  /**
   * Get details for one product definition
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `details$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  details(params: {

    /**
     * Product code
     */
    productCode: string;

    /**
     * Variant code
     */
    variantCode?: string;

    /**
     * Date
     */
    date?: string;

    /**
     * Is full product flag
     */
    fullProduct?: boolean;
    'Accept-Language'?: any;
  },
  context?: HttpContext

): Observable<PomProductDefinitionResponseDto> {

    return this.details$Response(params,context).pipe(
      map((r: StrictHttpResponse<PomProductDefinitionResponseDto>) => r.body as PomProductDefinitionResponseDto)
    );
  }

}
